var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'jam', params: { jamUrl: _vm.jam.url }}}},[(_vm.jam && _vm.jam.logo)?_c('img',{attrs:{"src":_vm.contentUrl,"alt":_vm.jam.title}}):_c('img',{attrs:{"src":_vm.stubUrl,"alt":_vm.jam.title}})])}
var staticRenderFns = []

export { render, staticRenderFns }